import React, { useState } from 'react';
import Hero from '../components/Hero';
import SpaCard from '../components/SpaCard';
import { spas } from '../data/charlotteSpas';

const Home = () => {
  const [filter, setFilter] = useState('Recommended');
  
  const sortedSpas = [...spas].sort((a, b) => {
    if (filter === 'Price: Low to High') return a.services[0].price - b.services[0].price;
    return 0; // Recommended (natural order)
  });

  return (
    <div className="min-h-screen bg-stone-50">
      <Hero />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col md:flex-row justify-between items-end mb-10">
          <div>
            <h2 className="font-playfair text-3xl md:text-5xl font-bold text-stone-900 mb-2">
              Charlotte Directory
            </h2>
            <p className="text-stone-600 text-lg">Curated wellness destinations across the Queen City.</p>
          </div>
          
          <div className="mt-6 md:mt-0">
            <select 
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="bg-white border border-stone-200 text-stone-700 text-sm font-bold rounded-2xl focus:ring-indigo-500 focus:border-indigo-500 block p-4 outline-none shadow-sm cursor-pointer"
            >
              <option>Recommended</option>
              <option>Price: Low to High</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {sortedSpas.map(spa => (
            <SpaCard key={spa.id} spa={spa} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default Home;